import React, { Fragment } from 'react';
export const SocialProofTicker = () => {
  const text = '+750 artesãs ✦ Feito no Brasil 🇧🇷 ✦ Funciona no celular ✦ Adeus, achômetro ✦ Cálculo em tempo real ✦ Sem planilha. Sem caderno. Sem chute. ✦ ';
  return <div className="bg-white py-4 overflow-hidden flex whitespace-nowrap border-y border-gold/20" data-id="element-583">
      <div className="animate-[scrollTicker_60s_linear_infinite] flex" data-id="element-584">
        <span className="text-ink font-medium text-sm tracking-wide px-4" data-id="element-585">
          {text.split('✦').map((part, i, arr) => <Fragment key={i} data-id="element-586">
              {part}
              {i < arr.length - 1 && <span className="text-gold mx-4" data-id="element-587">✦</span>}
            </Fragment>)}
        </span>
        <span className="text-ink font-medium text-sm tracking-wide px-4" data-id="element-588">
          {text.split('✦').map((part, i, arr) => <Fragment key={`repeat-${i}`} data-id="element-589">
              {part}
              {i < arr.length - 1 && <span className="text-gold mx-4" data-id="element-590">✦</span>}
            </Fragment>)}
        </span>
      </div>
    </div>;
};